import Model from './BaseModel'
import i18n from '@/plugins/i18n'
import Category from './Category'

export default class CycleRule extends Model {
    resourceName() {
        return 'rules'
    }

    baseURL() {
        return `${super.baseURL()}`
    }

    getCreateUrl() {
        return `${this.baseURL()}`
    }

    getUpdateUrl() {
        return `${super.getUpdateUrl()}`
    }

    fields() {
        return [
            'id',
            'category_id',
            'max_value',
            'min_value',
            'percentage',
            'cycle_rule',
            'rule_type',
            'deleted_at',
        ]
    }

    appends() {
        return ['category_id']
    }

    aliases() {
        return {
            rule_type: 'type',
        }
    }

    computed() {
        return {
            active(cycleRule) {
                return cycleRule.deleted_at ? false : true
            },

            rangeDescription(cycleRule) {
                const min = cycleRule.min_value
                const max = cycleRule.max_value
                return `${min}-${max || '∞'} clientes`
            },

            percentageFormatted(cycleRule) {
                return i18n.n(cycleRule.percentage / 100, 'percent')
            },
        }
    }

    relationships() {
        return {
            category: new Category(),
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.cycle_rule.attributes.min_value'),
                value: 'min_value',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.cycle_rule.attributes.max_value'),
                value: 'max_value',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.cycle_rule.attributes.percentage'),
                value: 'percentage',
                sortable: false,
                align: 'center',
            },
            {
                text: i18n.t('resources.default.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
